import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import {
  type ArenaOffersName,
  type ArenaPackRewardDto,
  type BoxReward,
} from '@/common/types/shop/marketBoxes';
import { rewardArray } from '@/components/ui/RewardBlockItems/rewardArray';
import RewardBlockItems from '@/components/ui/RewardBlockItems/RewardBlockItems';

interface prop {
  name?: ArenaOffersName;
  reward: BoxReward | ArenaPackRewardDto;
  classNames?: string;
  offerId?: string;
  variant: 'big' | 'medium' | 'small' | 'huge';
}

const RewardArray: React.FC<prop> = ({
  reward,
  classNames,
  offerId,
  variant,
}) => {
  const [rewardItems, setRewardItems] = useState(() => rewardArray(reward));
  useEffect(() => {
    setRewardItems(rewardArray(reward));
  }, [reward]);
  const totalItemsCount = rewardItems.length;
  let firstRowItems;
  let secondRowItems;

  if (totalItemsCount === 5) {
    firstRowItems = rewardItems.slice(0, 3);
    secondRowItems = rewardItems.slice(3); // 3+2
  } else if (totalItemsCount === 4) {
    firstRowItems = rewardItems.slice(0, 2);
    secondRowItems = rewardItems.slice(2); // 2+2
  } else if (totalItemsCount === 6) {
    firstRowItems = rewardItems.slice(0, 3);
    secondRowItems = rewardItems.slice(3); // 3+3
  } else {
    firstRowItems = rewardItems.slice(0, 4);
    secondRowItems = rewardItems.slice(4);
  }

  return (
    <div className={cn(classNames, 'flex gap-[4px] flex-col')}>
      <div className="flex gap-[4px]">
        {firstRowItems.map((el, i) => (
          <RewardBlockItems
            key={el.value + '_' + i}
            {...el}
            variant={variant}
            offerId={offerId}
          />
        ))}
      </div>
      <div className="flex gap-[4px]">
        {secondRowItems.map((el, i) => (
          <RewardBlockItems
            {...el}
            variant={variant}
            key={el.value + '_' + i}
            offerId={offerId}
          />
        ))}
      </div>
    </div>
  );
};

export default RewardArray;
